<script>
export default {
    name: "PaymentDetailsPrint",

    data() {

        return {
            paymentDetails: [],
        };
    },

    computed: {

        totalPaid() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.paid))
                .reduce((sum, amount) => sum + amount);
        },

        totalAmount() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.amount))
                .reduce((sum, amount) => sum + amount);
        },

        totalBalance() {
            if(!this.paymentDetails.length) return 0;

            return this.paymentDetails.map(paymentD => parseFloat(paymentD.balance))
                .reduce((sum, amount) => sum + amount);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchPaymentDetails(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => { window.print(); }, 200);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPaymentDetails() {
            
            return this.$http.get(`Accounts/GetConsultantPaymentsPaidDetails?InvoiceRef=${this.$route.query.InvoiceRef}`)
                .then(response => {
                    this.paymentDetails=response.data;
                }).catch(() => { });
        },
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full text-center my-3">
            <h5 class="font-bold text-base uppercase">Consultant Payments Slip</h5>
        </div>
    <div class="w-full">
        <table class="table">
            <tbody class="text-sm">
                <tr>
                    <th class="p-1">Consultant</th>
                    <th class="p-1">Transaction Date</th>
                    <th class="p-1">Payment Date</th>
                    <th class="p-1">Patient</th>
                    <th class="p-1">IP No</th>
                    <th class="p-1">OP No</th>
                    <th class="p-1">Service</th>
                    <th class="p-1">Amount</th>
                    <th class="p-1">Paid</th>
                    <th class="p-1">Balance</th>
                    <th class="p-1">Ref</th>
                    <th class="p-1">Comment</th>
                </tr>
                <tr v-for="(paymentD,idx) in paymentDetails" :key="idx">
                    <td class="p-px">{{ paymentD.consultant }}</td>
                    <td class="p-px">{{ paymentD.billDate | dateFormat }}</td>
                    <td class="p-px">{{ paymentD.trxDate | dateFormat }}</td>
                    <td class="p-px">{{ paymentD.names }}</td>
                    <td class="p-px">{{ paymentD.ipfileno || `-` }}</td>
                    <td class="p-px">{{ paymentD.opfileno || `-` }}</td>
                    <td class="p-px">{{ paymentD.itemName }}</td>
                    <td class="p-px">{{ paymentD.amount | numberFormat }}</td>
                    <td class="p-px">{{ paymentD.paid | numberFormat }}</td>
                    <td class="p-px">{{ paymentD.balance | numberFormat }}</td>
                    <td class="p-px">{{ paymentD.receiptNo || `-` }}</td>
                    <td class="p-px">{{ paymentD.invoiceMemo || `-` }}</td>
                </tr>
                <tr>
                    <th class="p-tiny" colspan="4">
                        Total Amt: {{ totalAmount | numberFormat }}
                    </th>
                    <th class="p-tiny" colspan="4">
                        Total Paid: {{ totalPaid | numberFormat  }}
                    </th>
                    <th class="p-tiny" colspan="4">
                        Total Balance: {{ totalBalance | numberFormat }}
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>